import { render, staticRenderFns } from "./deliveryAddress.vue?vue&type=template&id=6d505b34&scoped=true&"
import script from "./deliveryAddress.vue?vue&type=script&lang=js&"
export * from "./deliveryAddress.vue?vue&type=script&lang=js&"
import style0 from "./deliveryAddress.vue?vue&type=style&index=0&id=6d505b34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d505b34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d505b34')) {
      api.createRecord('6d505b34', component.options)
    } else {
      api.reload('6d505b34', component.options)
    }
    module.hot.accept("./deliveryAddress.vue?vue&type=template&id=6d505b34&scoped=true&", function () {
      api.rerender('6d505b34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/my/address/deliveryAddress.vue"
export default component.exports